<template>
    <div>
        <h3>{{$t('intern_aufwerten.title')}}</h3>
        <div v-html="$t('intern_aufwerten.aufwerten_text')"></div>
        <div class="my-3">
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + startseite" class="card-img">
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_aufwerten.aufwerten_us_fotolink')}}</h5>
                            <ul class="px-3 font-12">
                                <li>{{$t('intern_aufwerten.aufwerten_text_fotolink')}}</li>
                                <li>{{$t('intern_aufwerten.aufwerten_text_2fotolink')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + category" class="card-img">
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_aufwerten.aufwerten_us_fotokategorie')}}</h5>
                            <ul class="px-3 font-12">
                                <li>{{$t('intern_aufwerten.aufwerten_text_fotokategorie')}}</li>
                                <li>{{$t('intern_aufwerten.aufwerten_text_2fotokategorie')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + topinserat" class="card-img">
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_aufwerten.aufwerten_us_topinserat')}}</h5>
                            <ul class="px-3 font-12">
                                <li>{{$t('intern_aufwerten.aufwerten_text_topinserat')}}</li>
                                <li>{{$t('intern_aufwerten.aufwerten_text_2topinserat')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + dailypushup" class="card-img">
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_aufwerten.aufwerten_us_dailypushup')}}</h5>
                            <ul class="px-3 font-12">
                                <li>{{$t('intern_aufwerten.aufwerten_text_dailypushup')}}</li>
                                <li>{{$t('intern_aufwerten.aufwerten_text_2dailypushup')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + weeklypushup" class="card-img">
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_aufwerten.aufwerten_us_weeklypushup')}}</h5>
                            <ul class="px-3 font-12">
                                <li>{{$t('intern_aufwerten.aufwerten_text_weeklypushup')}}</li>
                                <li>{{$t('intern_aufwerten.aufwerten_text_2weeklypushup')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'zusatzleistung',
        data() {
            return {
                cdn: '',
                startseite: '/images/zusatzoptionen/fotolinks.png',
                category: '/images/zusatzoptionen/suchergebnis.png',
                topinserat: '/images/zusatzoptionen/topinserat.png',
                dailypushup: '/images/zusatzoptionen/24h.png',
                weeklypushup: '/images/zusatzoptionen/7d.png',
            }
        },
        created() {
            document.title = 'Zusatzleistung'
            this.$http.get('/api/getCDN').then(response => {
                this.cdn = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    }
</script>

<style scoped>
.card-body{
    padding: 0.25rem;
}
</style>